<template>
  <div
    class="search-panel"
    :style="[
      isMobile ? { left: '50px !important' } : { left: '10px !important' },
    ]"
  >
    <font-awesome-icon
      :icon="icon"
      size="lg"
      @click.prevent="searchArea = !searchArea"
      class="searchIcon"
    />
    <transition name="expand">
      <v-text-field
        :class="{ showInput: searchArea }"
        class="v-input--is-focused-alt"
        placeholder="جستجو"
        v-model="searchInput"
        dense
      ></v-text-field>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      searchArea: false,
    };
  },
  computed: {
    icon() {
      return this.searchArea ? "times" : "search";
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    searchInput: {
      get() {
        return this.$store.getters.searchInput;
      },
      set(value) {
        this.$store.commit("SET_SEARCH_INPUT", value);
      },
    },
  },
};
</script>
<style scoped>
.search-panel {
  position: fixed !important;
  top: 0;
width: 40%;
  z-index: 2 !important;
  color: white !important;
  direction: ltr;
}
.searchIcon {
  color: white !important;
  font-size: 1.7em !important;
  margin-top: 20px !important;
  margin-left: 10px !important;
  float: left;
  cursor: pointer;
}

.v-input {
  margin: 12px 10px 0px 40px !important;
  transition: 0.25s ease-out;
  width: 0;
  transition-property: width;
  color: white !important;
}

.showInput {
  transition: 0.25s ease-out;
  max-width: 500px;
  transition-duration: 0.5s;
  transition-property: width;
  width: 60%;
}

.expand-enter-active,
.expand-leave-active {
  transition-property: width;
  transition-duration: 0.5s;
}

.expand-leave-to {
  width: 200px;
}

.expand-enter {
  width: 0;
}
::placeholder {
  color: #ffffffc0 !important;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ffffffc0 !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #ffffffc0 !important;
}
</style>
